export default __webpack_public_path__ + "static/media/logo-dark.93be8ade.png";